import purify from '../../node_modules/dompurify/dist/purify.es.js';
import React__default, { useState, useRef, useEffect } from 'react';
import { Anchor, P1 } from '@zooplus/ui-components';
import { useTranslation } from '../../hooks/use-translations.js';
import { CartService } from '../../services/CartService.js';
import img from '../common/assets/images/new_autoship_graphics.png.js';
import { FodModal } from './fod-modal/FodModal.js';
import styles from './FodBanner.module.scss.js';
import '../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const FodBanner = (props) => {
    const [fodCapping, setFodCapping] = useState(undefined);
    const { site } = useSiteContext();
    const { t } = useTranslation(site.realm);
    const [showModal, setShowModal] = useState(false);
    const currentParams = useRef({
        siteDomain: site.domain,
    });
    useEffect(() => {
        const params = currentParams.current;
        if (params.siteDomain) {
            CartService(undefined)
                .getFODCapping(params.siteDomain)
                .then((response) => {
                if (response) {
                    setFodCapping(response.firstOrderDiscountCappingValue);
                }
            });
        }
    }, [currentParams.current.siteDomain]);
    const openModal = (e) => {
        e.preventDefault();
        setShowModal(true);
    };
    const text = purify.sanitize(t('checkout.fod-banner.text', { fodDiscount: props.fodPercentage }));
    const combinedHTML = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("span", { dangerouslySetInnerHTML: { __html: text } }),
        ' ',
        React__default.createElement(Anchor, { href: "#", onClick: openModal, className: styles.link }, t('checkout.fod-banner.details'))));
    const componentToRender = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("img", { className: styles.cartLogo, src: img, alt: "Autoshipment cart logo" }),
        React__default.createElement(P1, null, combinedHTML),
        React__default.createElement(FodModal, { isOpen: showModal, setIsOpen: setShowModal, fodPercentage: props.fodPercentage, fodCapping: fodCapping })));
    return (React__default.createElement(React__default.Fragment, null, fodCapping && (React__default.createElement("div", { className: styles.fodBannerBox, "data-test-id": `first-order-discount-banner` }, componentToRender))));
};

export { FodBanner };
//# sourceMappingURL=FodBanner.js.map
